/**
 * @param { String } ref - The input string from the scan
 * @param { String } prefix - a known prefix the string may have
 * @returns { Boolean } - true for serial, false for locator
 */
const isSerialRef = ( ref, prefix = 'id' ) => ref.toLowerCase().startsWith( prefix );

/**
 * @param { String } ref - The input string from the scan
 * @returns { Boolean } - true for serial, false for locator
 */
const isNumeric = ( ref ) => /^\d+$/.test( ref );

/**
 * @param { String } ref - The input string from the scan
 * @returns { Boolean } - true for empty String, false for anything else
 */
const isEmptyString = ( ref ) => /^$/.test( ref );

/**
 * @param { String } ref - The scanned value to search for
 * @param { Object[] } list - the array of scanned items, MUST be objects with property serial
 * @returns { Boolean } - True when list contains ref
 */
const hasItem = ( ref, list ) => list.some( ( item ) => item.serial === ref );

export default {
    isSerialRef,
    isNumeric,
    hasItem,
    isEmptyString,

};
